export default __webpack_public_path__ + "static/media/8.82c746d9.jpg";